import { ClassCardsListCombinedProps } from './types';

const usePresenter = (props: ClassCardsListCombinedProps): ClassCardsListCombinedProps => {
  return props;
};

export default usePresenter;
